module.exports = __webpack_public_path__ + "static/media/mic_disabled_light.2959c39a.svg";